import Vue from 'vue'


Vue.filter('ellipsis', function(str) {
    if(str.length >= 6){
        return  `${str.substring(0,5)}...`
    }
    return str
});
/* 单号分段 */
Vue.filter('text_4', value => {
    return value.replace(/(\d{4})(?=\d)/g,"$1 ")
})
Vue.filter('text_3', value => {
    return value.replace(/(\d{3})(?=\d)/g,"$1 ")
})
/**
 * @param {string} str 文字
 */
Vue.filter('ellipsis_3', function(str) {
    if(str.length >= 4){
        return  `${str.substring(0,3)}...`
    }
    return str
});
